// extracted by mini-css-extract-plugin
module.exports = {"termsOfService":"styles_termsOfService__RqWCy","termsOfService__content":"styles_termsOfService__content__YK85B"};